module.exports = __webpack_public_path__ + "static/media/high-middle-4.8625db46.png";